import React, { useMemo } from "react";

import moment from "moment";

import {
  Button,
  Dialog,
  Grid,
  IconButton,
  makeStyles,
  Typography,
  withStyles,
} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";

const styles = (theme) => ({
  dialogContainer: {
    borderRadius: theme.spacing(2),
  },
  titleSection: {
    padding: theme.spacing(2),
  },
  titleText: {
    alignSelf: "center",
  },
  closeButton: {
    padding: 0,
  },
  hr: {
    margin: 0,
    color: theme.palette.grey[400],
  },
  container: {
    padding: theme.spacing(1),
    minHeight: "80px",
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.spacing(2),
    borderColor: theme.palette.grey[300],
    borderWidth: "1px",
    borderStyle: "solid",
    marginBottom: theme.spacing(2),
  },
  fab_max: {
    minWidth: "initial",
    height: "initial",
    fontSize: "10px",
    padding: "0px 4px",
    marginLeft: theme.spacing(0.5),
    boxShadow: "none",
    borderRadius: theme.spacing(1),
  },
  input: {
    ...theme.typography.h5,
    width: "100%",
  },
  infoLoadingBTNBox: {
    margin: "0px -8px",
  },
  buttons: {
    borderRadius: "14px",
    width: "100%",
  },
});

const useStyles = makeStyles(styles);

// This is a modified version of MaterialUI's DialogTitle component, I've added a close button in the top right corner
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className={classes.titleSection}
      {...other}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignContent="center"
      >
        <Typography variant="body1" className={classes.titleText}>
          {children}
        </Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            className={classes.closeButton}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </Grid>
    </MuiDialogTitle>
  );
});

function WithdrawAcceptDialog({
  onClose,
  open,
  onAccept,
  amount,
  symbol,
  investTime,
  delay,
}) {
  const classes = useStyles();

  const showNote = useMemo(() => {
    const currentTimeStamp = moment.utc().unix();

    return investTime + delay > currentTimeStamp;
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      classes={{ paper: classes.dialogContainer }}
    >
      <DialogTitle onClose={onClose}>Withdraw Accept </DialogTitle>

      <hr className={classes.hr} />

      <div className={classes.titleSection}>
        <p>
          Are you sure you want to Withdraw {amount} {symbol} investment ?
        </p>

        {showNote && (
          <p className="text-danger">
            By withdrawing before the appointed time, in addition to paying the
            penalty, your profit up to this point will also maybe lost
          </p>
        )}

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button
              size="large"
              variant="outlined"
              color="secondary"
              onClick={onClose}
              className={classes.buttons}
            >
              Cancel
            </Button>
          </Grid>

          <Grid item xs={6}>
            <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={onAccept}
              className={classes.buttons}
            >
              Accept
            </Button>
          </Grid>
        </Grid>
      </div>
    </Dialog>
  );
}

WithdrawAcceptDialog.propTypes = {};

export default WithdrawAcceptDialog;
